import { useEffect } from 'react'
import RenderHTML from '../../../components/ui-components/RenderHTML'
import { goToPortfolioDashboard, lightImpactVibrate } from '../../../utils/appBridge'
import { useNewEliteLandingAnalyticsScreen } from '../analytics/NewEliteLandingAnalyticsContext'
import {
  NewEliteLandingEventId,
  trackNewEliteUserClicked
} from '../analytics/newEliteLandingAnalytics'
import { useEliteBuyCtaExtras } from '../../../components/elite/EliteBuyCtaExtrasContext'

const blackChevronRightSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
  <path d="M1 10.6001L5.53888 6.06118C5.6831 5.91699 5.6831 5.68321 5.53888 5.53901L1 1.0001" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

type GoToPortfolioButtonEventId =
  | typeof NewEliteLandingEventId.GoToPortfolioLocked
  | typeof NewEliteLandingEventId.GoToPortfolioGracePeriod

export function GoToPortfolioButton({ eventId }: { eventId: GoToPortfolioButtonEventId }) {
  const analyticsScreen = useNewEliteLandingAnalyticsScreen()
  const eliteBuyCtaExtras = useEliteBuyCtaExtras()

  const handleClick = () => {
    console.log('handleClick', eventId)
    lightImpactVibrate()
    trackNewEliteUserClicked(analyticsScreen, eventId, eliteBuyCtaExtras)
    goToPortfolioDashboard()
  }

  return (
    <div className='mb-6 self-end'>
      <div
        className='flex h-full cursor-pointer flex-row gap-2 self-end rounded-xl bg-white px-3 py-[6px] font-medium justify-self-center'
        onClick={handleClick}
      >
        <span>Go to Portfolio</span>
        <span className='my-auto'>
          <RenderHTML innerHTMLText={blackChevronRightSvg} />
        </span>
      </div>
    </div>
  )
}
